import EventBus from "../../../../util/EventBus";
import Applet from "../../Applet";
import PlatformDetailDialog from "../../../../components/PlatformDetailDialog";

const FULL = {"View": {xs: 12, sm: 12, md: 12, lg: 12, xl: 12},
              "Edit": {xs: 12, sm: 12, md: 12, lg: 12, xl: 12},
              "New":  {xs: 12, sm: 12, md: 12, lg: 12, xl: 12}};

/**
 * Add a record to a change order, and confirm removing one.
 *
 * CHANGEORDERUSID IS NOT ASKED FOR. It is the change order the dialog was opened from; offering it
 * as a field would invite putting a record into a change order nobody is looking at. The grid sets
 * it as scope before the dialog opens and the component reads it from there.
 *
 * DELETE MUST BE DECLARED, EVEN THOUGH ITS FIELDS ARE THE SAME. The dialog reads the action to
 * decide what it is doing; without this entry it falls back to the New layout AND to New's
 * behaviour, so "Remove from change order" opens an Add dialog with a Save button -- which would
 * add a second member rather than remove the chosen one. Same membership on purpose: a confirmation
 * should show the row it is about to remove.
 */
class ChangeOrderMemberFormApplet extends Applet {
    state = {
        Name: "ChangeOrderMemberFormApplet",
        Actions: {
            New: {
                Groups: [{
                    "identifier": "group1", "type": "standard", "selector": null, "characteristics": [],
                    "membership": [{id: "RecordName"}, {id: "Reason"}],
                }],
            },
            Delete: {
                Groups: [{
                    "identifier": "group1", "type": "standard", "selector": null, "characteristics": [],
                    "membership": [{id: "RecordName"}, {id: "Reason"}],
                }],
            },
        },
        Layout: {},
        Controls: {
            RecordName: {
                id: "RecordName",
                enterpriseComponentAttribute: "RecordName",
                placement: FULL,
                errors: [{validator: "Required", value: null, errorText: "A record is required."}],
                // A LONG LIST, so this renders as a read-only box with a chooser beside it rather
                // than a dropdown of every draft in the realm.
                // REQUIRED ON THE CONTROL, because the obligation belongs to RecordUSID -- which the
                // chooser fills through a pick map -- and RecordName is only how it is shown. Left
                // to the metadata the form would print "Optional" under a field you cannot save
                // without.
                csp: {autoFocus: true, multiline: false, placeholder: null, label: "Record",
                      size: "small", disabled: false, required: true},
                ip: {},
                type: "Select",
                requiresConfirmation: false,
            },
            Reason: {
                id: "Reason",
                enterpriseComponentAttribute: "Reason",
                placement: FULL,
                errors: [],
                csp: {autoFocus: false, multiline: true, rows: 2, placeholder: null,
                      label: "Why this record is in the change order", size: "small", disabled: false},
                ip: {},
                type: "TextField",
                requiresConfirmation: false,
            },
        },
    };

    cancel() {
        super.cancel();
        EventBus.components.emit("change-order-member-form-applet-cancel");
    };

    setAction(action) {
        super.setAction(action);
        if (action === "Save Completed") {
            EventBus.components.emit("change-order-member-form-applet-save");
        }
    };

    render() {
        return <PlatformDetailDialog applet={this}
                                     layout={this.state.Layout}
                                     controls={this.state.Controls}
                                     actions={this.state.Actions}
                                     title="Record in change order"
                                     enterpriseComponent={this.getEnterpriseComponent()}
                                     action={this.props.defaultAction}
                                     errorReportingMethod="RealTime"/>;
    }
}

export default ChangeOrderMemberFormApplet;
